import { BodySmallText } from '../typography/typography';
import { ICardSubsection } from './card-subsection-types';
import { CardSubsectionStyle } from './card-subsection-style';

const CardSubsection: React.FC<ICardSubsection> = ({ label, children, dataCy, className }) => {
  return (
    <CardSubsectionStyle className={className ? className : ''} data-cy={dataCy}>
      <div className="card-subsection-label m-12px">
        <BodySmallText weight={600}>{label}</BodySmallText>
      </div>
      <div className="card-subsection-form">{children}</div>
    </CardSubsectionStyle>
  );
};

export default CardSubsection;
